import { getGenericEndpoint } from './get.api';
import type { GetSigninResponse } from './types';

export const getSignin = async (lang?: string) => {
	return await getGenericEndpoint<GetSigninResponse>('signin', lang);
};
